// extracted by mini-css-extract-plugin
export default {"tabLinks":"TabItem_tabLinks__iz2cs","tabSelected":"TabItem_tabSelected__HUJgt","disabled":"TabItem_disabled__YPaKW"};